import { useContext, useMemo } from 'react';

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { PopperNavigationContext } from '../..';
import { AppBarMenuButtonContext } from '../app-bar-menu-button';

const SolutionCard = ({ solution, direction = "row", learnMore, sx }) => {

    const { t, i18n } = useTranslation('public');
    const navigate = useNavigate()

    const popperContext = useContext(PopperNavigationContext);
    const appBarContext = useContext(AppBarMenuButtonContext);

    const trimmedDescription = useMemo(() => {
        if (solution?.description) {
            const description = t(solution?.description)
            return description?.length > 200 ? description?.substring(0, 199) + "..." : description
        }
    }, [solution])

    return (
        <Card sx={{ display: 'flex', flexDirection: direction, ...sx, maxWidth: '440px', maxHeight: '180px', ...sx }}>
            <Box sx={{ flex: 1 }}>
                <CardMedia
                    component="img"
                    sx={{ width: '100%', height: '100% !important', objectFit: 'cover', transform: i18n.dir() === 'rtl' ? 'scaleX(-1)' : undefined }}
                    image={solution.image}
                />
            </Box>
            <Box sx={{ flex: 1.25, display: 'flex', flexDirection: 'column' }}>
                <CardContent sx={{ paddingInline: 3, paddingBlock: 2, height: '100%' }}>
                    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                        <Box overflow="hidden">
                            <Typography
                                sx={{
                                    color: "#1E1E1E",
                                    fontSize: '16px',
                                    fontStyle: 'normal',
                                    fontWeight: 600,
                                    lineHeight: 'normal',
                                    cursor: 'pointer',
                                    "&:hover": {
                                        color: 'primary.main'
                                    }
                                }}
                                onClick={() => {
                                    appBarContext?.handleClose()
                                    popperContext?.closePopperMenu()
                                    navigate(solution.href)
                                }}
                            >
                                {t(solution?.title)}
                            </Typography>
                            <Typography sx={{ color: "#1E1E1E", fontSize: '14px', fontStyle: 'normal', fontWeight: 300, lineHeight: 'normal', mt: 1 }}>
                                {trimmedDescription}
                            </Typography>
                        </Box>
                        <Link
                            onClick={() => {
                                appBarContext?.handleClose()
                                popperContext?.closePopperMenu()
                                navigate(solution.href)
                            }}
                            sx={{ color: 'blue.main', marginTop: 'auto', textTransform: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', fontSize: '14px', fontWeight: '600px', textDecoration: 'none' }}
                        >
                            {learnMore}
                            <ArrowForwardIcon sx={{ marginInlineStart: 1, fontSize: '20px', transform: i18n.dir() === 'rtl' ? 'scale(-1, -1)' : undefined }} />
                        </Link>
                    </Box>
                </CardContent>
            </Box>
        </Card>
    );
}

export default SolutionCard